import React from "react";

import styled from "@emotion/styled";

import Card from "./Card";

const InnerContainer = styled.div`
    padding-top: 50px;
    padding-bottom: 50px;
    ${({ theme }) => theme.paddings.containerOuterInner.left}
    ${({ theme }) => theme.paddings.containerOuterInner.right}
`;

const Columns = styled.div`
    display: grid;
    ${({ theme }) => theme.breakpoints.from.medium.css`
       grid-template-columns: 50% 50%;
       column-gap: 50px;
    `}
`;

const Column = styled.div`
    display: flex;
    flex-direction: column;
    row-gap: 80px;
`;

const OilfoxColumns = ({ leftItems, rightItems }) => {
    return (
        <InnerContainer>
            <Columns>
                <Column>
                    {leftItems.map((item, i) => (
                        <Card key={i} item={item} />
                    ))}
                </Column>
                <Column>
                    {rightItems.map((item, i) => (
                        <Card key={i} item={item} />
                    ))}
                </Column>
            </Columns>
        </InnerContainer>
    );
};

export default OilfoxColumns;
